var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHiwSearch = function SvgHiwSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.964 98.695"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 117"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 109"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 82"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 38"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 97",
    d: "M103.922 1.197a1.7 1.7 0 0 0-2.3.728L95.1 14.513H34.923a33.922 33.922 0 1 0 0 67.845H59.95l-6.653 12.843a1.706 1.706 0 0 0 3.028 1.571l7.469-14.414 35.151-67.845 5.706-11.016a1.706 1.706 0 0 0-.729-2.3ZM61.713 78.951h-26.79a30.514 30.514 0 0 1 0-61.028h58.413Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 124",
    d: "m23.574 19.101 20.7-2.648 24.017.807 26.508-.807-7.146 18.927-13.391 24.89-12.4 21.412H51.817L29.67 80.008l-12.986-6.134L6.109 61.257 2.121 47.83l2.381-10.913 7.512-11.571Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 110"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 107",
    d: "M61.65 67.137 48.376 53.862a15.592 15.592 0 1 0-2.443 2.443l13.275 13.273a1.727 1.727 0 1 0 2.443-2.442ZM36.236 56.263a12.1 12.1 0 1 1 12.1-12.1 12.11 12.11 0 0 1-12.1 12.099Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2
  })))));
};
export default SvgHiwSearch;